import React from 'react'
import styled from 'styled-components'
import {Box, Text} from '@miro-site/core'
import type {BoxProps} from '@miro-site/core'
import {Expand} from '../icons/Icons'

export interface HeaderProps extends BoxProps {
  children: React.ReactNode
  isExpanded: boolean
}

const Header: React.FC<HeaderProps> = ({children, isExpanded, ...props}) => {
  return (
    <HeaderStyled $variant="p0" as="div" {...props}>
      {children}
      <Icon $isExpanded={isExpanded}>
        <Expand />
      </Icon>
    </HeaderStyled>
  )
}

const Icon = styled(Box)<{$isExpanded?: boolean}>`
  transition: transform 0.2s ease-in-out;
  transform: ${props => (props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`

const HeaderStyled = styled(Text).attrs({
  $variant: 'p1',
  $styles: {
    height: [84, null, null, null],
  },
})`
  display: flex;

  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

export default Header
